import { render, staticRenderFns } from "./ToggleItem.vue?vue&type=template&id=5af5d56e&scoped=true"
import script from "./ToggleItem.vue?vue&type=script&lang=js"
export * from "./ToggleItem.vue?vue&type=script&lang=js"
import style0 from "./ToggleItem.vue?vue&type=style&index=0&id=5af5d56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5d56e",
  null
  
)

export default component.exports